import { update } from "immupdate";
import { PersistConfig } from "redux-persist";
import { AppLanguage, getDefaultLanguage } from "../i18n/I18nContext";
import { createReducer, createRootReducer, PerformAction } from "../utils/ReducerUtils";
import { AppStoreState } from "../store/RootReducer";

export const appReducerPersistConfig: Partial<PersistConfig<AppReducerState>> = {
  whitelist: ["version", "language", "filter", "table", "product", "cellNumber"],
};

interface SwitchLanguageMeta {
  readonly language: AppLanguage;
}

interface FiltersData {
  readonly filterSelectData?: any[];
  readonly filterData?: any[];
}

interface ProductMeta {
  readonly product: any[];
}

interface TableDragMeta {
  readonly tableData?: any;
}

interface FilterMeta {
  readonly filter?: FiltersData;
}

interface CellNumberMeta {
  readonly cellNumber: string;
}

enum ReducerActions {
  SwitchLanguage = "App/SwitchLanguage",
  SetFilter = "App/SetFilter",
  SetDragData = "App/TableDragData",
  SetProduct = "App/SetProduct",
  SetCellNumber = "App/SetCellNumber",
}

export interface AppReducerState {
  readonly language: AppLanguage;
  readonly filter?: any[];
  readonly tableData?: any;
  readonly product?: any[];
  readonly cellNumber?: string;
}

function getState(): AppReducerState {
  return {
    language: getDefaultLanguage(),
  };
}

export const appReducer = createRootReducer<AppReducerState>(
  getState(),

  createReducer([ReducerActions.SwitchLanguage], (state, { meta }) =>
    update(state, { language: meta.language }),
  ),

  createReducer([ReducerActions.SetFilter], (state, { meta }) =>
    update(state, { filter: meta.filter }),
  ),

  createReducer([ReducerActions.SetDragData], (state, { meta }) =>
    update(state, { tableData: meta.tableData }),
  ),

  createReducer([ReducerActions.SetProduct], (state, { meta }) =>
    update(state, { product: meta.product }),
  ),

  createReducer([ReducerActions.SetCellNumber], (state, { meta }) =>
    update(state, { cellNumber: meta.cellNumber }),
  ),
);

// ==================
// Selectors
// ==================

export const appLanguageSelector = ({ app }: AppStoreState): AppLanguage => app.language;

export function filterSelector(state: AppStoreState): any {
  return state.app.filter;
}

export function tableDragDataSelector(state: AppStoreState): any {
  return state.app.tableData;
}

export function cellNumberSelector(state: AppStoreState): string | undefined {
  return state.app.cellNumber;
}

export const productSelector = ({ app }: AppStoreState): any[] | undefined => app.product;

// ==================
// Actions
// ==================

export function switchLanguage(meta: SwitchLanguageMeta): PerformAction<SwitchLanguageMeta> {
  return { type: ReducerActions.SwitchLanguage, meta };
}
export function setFilter(meta: FilterMeta): PerformAction<FilterMeta> {
  return { type: ReducerActions.SetFilter, meta };
}
export function setTableDragData(meta: TableDragMeta): PerformAction<TableDragMeta> {
  return { type: ReducerActions.SetDragData, meta };
}
export function setProduct(meta: ProductMeta): PerformAction<ProductMeta> {
  return { type: ReducerActions.SetProduct, meta };
}
export function setCellNumber(meta: CellNumberMeta): PerformAction<CellNumberMeta> {
  return { type: ReducerActions.SetCellNumber, meta };
}
